import React from 'react';

import BuyerBidSummary from 'features/deals/DealStages/EventActionCards/BuyerBidSummary';
import { basisPointsToPercent } from 'features/deals/DealStages/EventActionCards/utils';
import { Button, CarveCardContainer } from 'ui-kit';

import {
  SellerDealsWithCarves_user_company_deals_bids,
  SellerDealsWithCarves_user_company_deals_performance_summary,
} from 'query/__generated__/SellerDealsWithCarves';

import BidHistory, { BidEntry, BidStatus } from './BidHistory';
import CarveComparisonTable from './CarveComparisonTable';

type Props = {
  bid: SellerDealsWithCarves_user_company_deals_bids;
  performanceSummary: SellerDealsWithCarves_user_company_deals_performance_summary;
  bidsHistory: SellerDealsWithCarves_user_company_deals_bids[];
  dealId: string;
};

const BidDetails = ({ bid, bidsHistory, performanceSummary, dealId }: Props) => {
  const carveSummary = bid?.carve_summary;

  const buildBidHistoryEntries = (
    bids: SellerDealsWithCarves_user_company_deals_bids[],
  ): BidEntry[] => {
    return bids.map((entry, index) => {
      const type = entry.bidder === 'BUYER' && index === 0 ? 'ORIGINAL BID' : 'COUNTER BID';

      const carveName = entry.carve?.length
        ? entry.carve[0].operand || 'Unnamed Carve'
        : 'Original Bid';

      const bidBasisPoints = entry.stipulations?.bid_basis_points ?? 0;
      const pricePercent = parseFloat(basisPointsToPercent(bidBasisPoints));

      const status: BidStatus = index === 0 ? 'Initial' : 'Rejected';

      return {
        type,
        carveName,
        pricePercent,
        status,
        timestamp: entry.created_date,
      };
    });
  };

  return (
    <div className="pl-4">
      <div className="border-l-4 border-yellow-400 bg-background-canvas">
        <div className="flex flex-col gap-4">
          <div className="mt-1 flex flex-nowrap gap-x-12 px-[20px]" id="pdf-content-bid-info">
            <div className="flex w-[50%] max-w-[420px] flex-col gap-4">
              <BuyerBidSummary bid={bid} />
            </div>
            <div className="flex w-[50%] gap-8">
              <CarveComparisonTable baseSummary={performanceSummary} carveSummary={carveSummary} />
            </div>
          </div>
          <div className="flex justify-start pl-5">
            <Button
              type="primary"
              size="compact"
              label="Take action"
              className="px-[6px]"
              onClick={() => {
                window.open(`/marketplace/deal/${encodeURIComponent(dealId)}`, '_blank');
              }}
            >
              Take action
            </Button>
          </div>

          {bidsHistory.length > 0 && (
            <>
              <div className="pl-5">
                <div className="max-w-[1200px] border-b border-gray-900" />
              </div>
              <BidHistory bids={buildBidHistoryEntries(bidsHistory)} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BidDetails;
